import demoResultPresets from './demoResultPresets';

const selectDemoPreset = (variantKey) => {
    if (variantKey && demoResultPresets[variantKey]) {
        return demoResultPresets[variantKey];
    }

    return demoResultPresets.innovator;
};

export default selectDemoPreset;
